import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { IeLynxUser } from "../../common/models/eLynxUser";
import i18n from "../../services/localization-service/i18n";
import Enumerable from "linq";
import { useCallback } from "react";


export type UseUserFavoriteAccessibleUsersOptionsType = {
    filterText?: string;
    //sortBy?: UserSortEnum;
    filterRoleIDs?: number[];
    excludeDisabled?: boolean;
};

export type UseUserFavoriteAccessibleUsersParameters = {
    groupID: number,
    favoriteID: number,
    options?: UseUserFavoriteAccessibleUsersOptionsType;
} & BaseUseQueryParameters<IeLynxUser[]>;


function selectUsers(data: IeLynxUser[], options?: UseUserFavoriteAccessibleUsersOptionsType): IeLynxUser[] {
    const users = data.map(u => {
        return {
            ...u,
            firstName: (u.firstName?.length ?? 0) > 0
                ? u.firstName
                : i18n.t("noFirstName"),
            lastName: (u.lastName?.length ?? 0) > 0
                ? u.lastName
                : i18n.t("noLastName"),
            login: (u.loginName?.length ?? 0) > 0
                ? u.loginName
                : i18n.t("noLogin"),
        };
    });
    const filterText = options?.filterText?.toLowerCase() ?? "";

    // Filter users
    let query = filterText && filterText.length > 0
        ? Enumerable
            .from(users)
            .where(user => {
                return (user.lastName?.toLowerCase().indexOf(filterText) ?? -1) !== -1 ||
                    (user.firstName?.toLowerCase().indexOf(filterText) ?? -1) !== -1 ||
                    (user.login?.toLowerCase().indexOf(filterText) ?? -1) !== -1;
            })
        : Enumerable.from(users);

    if (
        options?.filterRoleIDs &&
        options.filterRoleIDs.length > 0 &&
        options.filterRoleIDs[0] !== -1
    ) {
        query = query.where(user =>
            user.associatedRoleIDs?.some(role =>
                options.filterRoleIDs?.includes(role) ?? false
            ) ?? false
        );
    }

    // // Sort users
    // switch (options?.sortBy) {
    //     case UserSortEnum.LastNameAsc:
    //         query = query
    //             .orderBy(u => u.lastName?.toLowerCase())
    //             .thenBy(u => u.firstName?.toLowerCase());
    //         break;

    //     case UserSortEnum.LastNameDesc:
    //         query = query
    //             .orderByDescending(u => u.lastName?.toLowerCase())
    //             .thenBy(u => u.firstName?.toLowerCase());
    //         break;

    //     case UserSortEnum.FirstNameAsc:
    //         query = query
    //             .orderBy(u => u.firstName?.toLowerCase())
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;

    //     case UserSortEnum.FirstNameDesc:
    //         query = query
    //             .orderByDescending(u => u.firstName?.toLowerCase())
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;

    //     case UserSortEnum.UserEmailAsc:
    //         query = query
    //             .orderBy(u => u.login?.toLowerCase());
    //         break;

    //     case UserSortEnum.UserEmailDesc:
    //         query = query
    //             .orderByDescending(u => u.login?.toLowerCase());
    //         break;

    //     case UserSortEnum.LastActivityAsc:
    //         query = query
    //             .orderBy(u => u.lastActivityTimestamp ?? "")
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;

    //     case UserSortEnum.LastActivityDesc:
    //         query = query
    //             .orderByDescending(u => u.lastActivityTimestamp ?? "")
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;

    //     case UserSortEnum.MobileAccessAsc:
    //         query = query
    //             .orderBy(u => !!u.isMobileAccessEnabled)
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;

    //     case UserSortEnum.MobileAccessDesc:
    //         query = query
    //             .orderByDescending(u => !!u.isMobileAccessEnabled)
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;

    //     case UserSortEnum.UserEnabledAsc:
    //         query = query
    //             .orderBy(u => !u.isDisabled)
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;

    //     case UserSortEnum.UserEnabledDesc:
    //         query = query
    //             .orderByDescending(u => !u.isDisabled)
    //             .thenBy(u => u.lastName?.toLowerCase());
    //         break;
    // }

    if(options?.excludeDisabled){
        query = query.where(r => !r.disabled);
    }

    return query.toArray();
    // const filteredAndSortedUsers = query.toArray();

    // return {
    //     data: {
    //         ...data,
    //         users: filteredAndSortedUsers
    //     },
    //     totalCount: users.length,
    //     filteredCount: filteredAndSortedUsers.length
    // };
}




export function useUserFavoriteAccessibleUsers({
    groupID,
    favoriteID,
    options,
    enabled,
    onError,
    onSuccess
}: UseUserFavoriteAccessibleUsersParameters) {
    return useQuery<IeLynxUser[], RestError>(
        keys.favoriteAccessibleUsers(groupID, favoriteID),
        async ({ signal }) => {
            return UIPersonalizationDataService.getUserFavoriteAccessibleUsers(groupID, favoriteID, signal);
        },  {
        select: useCallback(
                (data: IeLynxUser[]) => selectUsers(data, options),
                [options]
            ),
            enabled,
            onError,
            onSuccess
        });
}